//View Keys
export default {
  maputilities_vehiclelist_visible_groups: 'Manage Visible Tags',
  maputilities_vehiclelist_no_items: "This Tag doesn't have any items",
  maputilities_vehiclelist_no_click_option: "Vehicle does not have the coordinates yet",
  maputilities_vehiclelist_follow_unit: "Follow",
  maputilities_vehiclelist_showAll: "Show All",
  maputilities_vehiclelist_hiddenAll: "Hide All",
};